(() => {
  const body = document.querySelector("body");

  if (!["commercial-equipment", "home-brewing-equipment"].includes(body.id)) {
    return;
  }

  function removeImagesFromCollectionList() {
    const topCollectionListSlider = document.querySelector(
      "main#main css-slider"
    );

    const collectionListGrid = topCollectionListSlider.querySelector(".grid");

    const cards = collectionListGrid.querySelectorAll(".card");

    for (const card of cards) {
      console.log(card);
      const cardImage = document.querySelector(".card__image");
      cardImage.remove();
    }
  }

  // removeImagesFromCollectionList();
})();
